import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import CallMergeOutlinedIcon from "@mui/icons-material/CallMergeOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import DesktopSteps from "./DesktopSteps";
import MobileSteps from "./MobileSteps";

const title = "How the Process Works";
const description =
  "A structured approach to capturing, analyzing, and transforming requirements into actionable DAM solutions.A structured approach to capturing, analyzing, and transforming requirements into actionable DAM solutions.";
const stepsData = [
  {
    number: "01",
    icon: InboxOutlinedIcon,
    title: "Input Collection",
    description: "Stakeholders fill out the questionnaire.",
  },
  {
    number: "02",
    icon: AnalyticsOutlinedIcon,
    title: "Data Analysis",
    description: "Review & interpret responses",
  },
  {
    number: "03",
    icon: CallMergeOutlinedIcon,
    title: "Consolidation",
    description: "Combine insights across teams",
  },
  {
    number: "04",
    icon: EditNoteOutlinedIcon,
    title: "Define Requirements",
    description: "Outline functional needs",
  },
  {
    number: "05",
    icon: DescriptionOutlinedIcon,
    title: "Create Specifications",
    description: "Prepare technical documents",
  },
];

export default function HowWork() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        px: {
          xs: "16px",
          sm: "24px",
          md: "84px",
        },
        py: {
          xs: "30px",
          sm: "48px",
          md: "48px",
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "24px",
              sm: "32px",
              md: "40px",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 1.25,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              sm: "16px",
              md: "18px",
            },
            fontWeight: 400,
            color: "#666666",
            lineHeight: 1.7,
            // mb: 5,
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Steps and its Data */}
      <Box>
        {isDesktop ? (
          <DesktopSteps stepsData={stepsData} />
        ) : (
          <MobileSteps stepsData={stepsData} />
        )}
      </Box>
    </Box>
  );
}
